import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Providers } from '@/app/providers';
import { Routeur } from '@/app/router';

import '@/styles/theme.css';

const racine = document.getElementById('racine');

if (!racine) {
  throw new Error("L'element racine est introuvable dans index.html.");
}

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      <Providers>
        <Routeur />
      </Providers>
    </BrowserRouter>
  </StrictMode>,
);
